import { TQueryParams, TStoreParams } from '@/domain/Pages.domain';
import { addDays, format, startOfToday } from 'date-fns';
import { SERVER_FORMAT_DATE } from '../constants/dates';

export const createParamsByActivities = (
    list: { id: string }[],
    query?: TQueryParams
): [string, TStoreParams] => {
    const activity_ids = list?.map((v) => v.id).join();

    const currentDate = startOfToday();

    const from = currentDate;
    const to = addDays(from, 6);
    const promo = query?.promocode;

    return [
        activity_ids,
        {
            from: format(from, SERVER_FORMAT_DATE),
            to: format(to, SERVER_FORMAT_DATE),
            ...(promo && { promocode: promo }),
        },
    ];
};
